<template>
  <ChatBlock website-type="mainSite" />
</template>

<script setup lang="ts">
import ChatBlock from "@solvari/components/blade/chat/ChatBlock.vue";
</script>
